import { render, staticRenderFns } from "./_Buy.vue?vue&type=template&id=2f37495f"
import script from "./_Buy.vue?vue&type=script&lang=js"
export * from "./_Buy.vue?vue&type=script&lang=js"
import style0 from "./_Buy.vue?vue&type=style&index=0&id=2f37495f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports